module.exports = __webpack_public_path__ + "img/home.50c2a51c.jpg";